import { render, staticRenderFns } from "./visitList.vue?vue&type=template&id=4a80d0e1&scoped=true&"
import script from "./visitList.vue?vue&type=script&lang=js&"
export * from "./visitList.vue?vue&type=script&lang=js&"
import style0 from "./visitList.vue?vue&type=style&index=0&id=4a80d0e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80d0e1",
  null
  
)

export default component.exports